import { styled, theme } from "../../../../styles/stitches.config"

export const SContainer = styled("div", {
  backgroundColor: theme.colors.white,
  width: "max-content",
  boxShadow: theme.shadows.default,
  padding: `${theme.space.s7} ${theme.space.s6}`,
})
